/* @flow */
import React from 'react';
import cx from 'classnames';
import Link from 'components/Link.jsx';
import LinkConstants from 'constants/LinkConstants';
import Text from 'components/Text.jsx';

class TosText extends React.Component {
  render() {
    return (
      <Text color="thunder" size="xxsmall" className={cx('TosText', this.props.className)}>
        By signing up, you agree to our
        {' '}
        <Link href={LinkConstants.TERMS_OF_SERVICE} target="_blank" color="thunder" weight="semibold" noWrap>
          Terms of Service
        </Link>
        {' '}
        and
        {' '}
        <Link href={LinkConstants.PRIVACY_POLICY} target="_blank" color="thunder" weight="semibold" noWrap>
          Privacy Policy
        </Link>
        .
      </Text>
    );
  }
}

export default TosText;



// WEBPACK FOOTER //
// ./src/components/TosText.jsx